import styled from 'styled-components';
export const Wrapper = styled.div `
  display: block;
  position: absolute;
  z-index: 11; // infront of session arrows and other labels
  background-color: white;
  width: 100%;
  border: 0.1rem solid var(--border);
  //border-top: none;
  top: calc(100% + -3.6rem); // from margin on calendar step and a 6px offset
  padding-top: 0.6rem;
  border-bottom-left-radius: var(--border-radius-sm);
  border-bottom-right-radius: var(--border-radius-sm);
  overflow: hidden
;
  
  .react-datepicker {
    margin-top: 1rem;
    box-shadow: none;
    
    .react-datepicker__day-names,
    .react-datepicker__week {
      justify-content: center;
    }
    
    .react-datepicker__day-names {
      border-bottom: 0.2rem solid var(--border);
    }
    
    .react-datepicker__day--outside-month {
      pointer-events: none;
      opacity: 0;
      visibility: hidden;
    }

    .react-datepicker__day-name {
      font: var(--paragraph-small-font);
      color: var(--text);
    }
    
    .react-datepicker__day--disabled {
      cursor: not-allowed;
      
      &::before, &:hover::before {
        content: none;
      }
      
      &, span {
        color: #ccc;
      }
    }
  }
`;
export const LoadingContent = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3.3rem 2.5rem 3.3rem;
`;
export const LoadingTitle = styled.span `
  display: block;
  margin-top: 2rem;
  font: var(--heading-four-font);
  color: var(--primary-darker);
`;
export const LoadingCopy = styled.span `
  font: var(--paragraph-font);
  color: var(--text);
`;
export default {
    Wrapper,
};
